import { gql } from "@apollo/client";

export const FEES_FOR_PAX = gql`
  fragment fees on KeyValuePair_StringGraphType_Passenger {
    passengerKey: key
    value {
      fees {
        code
        detail
        flightReference
        ssrCode
        ssrNumber
        type
        passengerFeeKey
        isConfirmed
        serviceCharges {
          amount
          code
          currencyCode
          detail
          type
        }
      }
    }
  }
`;

export const FEES_FOR_PAX_WITHOUT_AMOUNT = gql`
  fragment feesWithoutAmount on KeyValuePair_StringGraphType_Passenger {
    passengerKey: key
    value {
      fees {
        code
        detail
        flightReference
        ssrCode
        ssrNumber
        type
        passengerFeeKey
        isConfirmed
        serviceCharges {
          code
          currencyCode
          detail
          type
        }
      }
    }
  }
`;

export const BREAKDOWN_WITHOUT_AMOUNT = gql`
  fragment breakdownWithoutAmount on BookingPriceBreakdown {
    authorizedBalanceDue
    balanceDue
    journeys {
      value {
        journeyKey
      }
    }

    passengers {
      value {
        passengerKey
      }
    }
  }
`;

export const BREAKDOWN = gql`
  fragment breakdown on BookingPriceBreakdown {
    authorizedBalanceDue
    balanceDue
    journeys {
      value {
        journeyKey
        totalAmount
        totalDiscount
        totalPoints
        totalTax
      }
    }
    journeyTotals {
      totalDiscount
      totalTax
      totalAmount
    }
    passengerTotals {
      infant {
        ...charge
      }
      seats {
        ...charge
      }
      specialServices {
        ...charge
      }
    }
    passengers {
      value {
        passengerKey
        convenience {
          ...charge
        }
        infant {
          ...charge
        }
        nameChanges {
          ...charge
        }
        seats {
          ...charge
        }
        services {
          ...charge
        }
        specialServices {
          ...charge
        }
        spoilage {
          ...charge
        }
        upgrades {
          ...charge
        }
      }
    }
    total: totalCharged
  }
`;

export const BREAKDOWN_FORMAT2 = gql`
  fragment breakdownV2 on BookingPriceBreakdown {
    authorizedBalanceDue
    balanceDue
    journeyTotals {
      totalDiscount
      totalTax
      totalAmount
    }
    passengerTotals {
      infant {
        ...charge
      }
      seats {
        ...charge
      }
      specialServices {
        ...charge
      }
    }
    total: totalCharged
  }
`;

export const SSRS = gql`
  fragment ssrs on Journey {
    segments {
      segmentKey
      passengerSegment {
        passengerKey: key
        value {
          ssrs {
            count
            feeCode
            passengerKey
            ssrCode
            ssrKey
            ssrNumber
            inBundle
            market {
              departureDate
              destination
              origin
            }
          }
        }
      }
    }
  }
`;

export const CHECKIN_REQUIREMENTS_FRAGMENT = gql`
  fragment checkinRequirements on CheckinRequirements {
    isValid
    passengers {
      passengerKey: key
      value {
        isValid
        invalidSsrs
        documentRequirements {
          documentsOnFile
          isValid
          unhandledDocuments {
            eligibleDocuments {
              documentTypeCode
              group
            }
            governmentInstance
            numberOfMissingDocuments
          }
        }
        addressRequirements {
          addressesOnFile
          isValid
          unhandledAddresses
        }
        restrictions {
          description
          restriction
        }
      }
    }
    governmentProgramRequirements {
      key
      value {
        additionalDataRequired
        governmentInstance
        requiredDocumentFields
      }
    }
    restrictions
  }
`;
